import request from '../utils/request'
const serviceName = 'processapprovalnew'

export function getAllContentList(data) {
  return request({
    url:`/${serviceName}/documentEnum/getAllContentList`,
    method:'post',
    data
  })
}

export function saveContent(data) {
  return request({
    url:`/${serviceName}/documentEnum/saveContent`,
    method:'post',
    data
  })
}

export function getMaxOrderNum(data) {
  return request({
    url:`/${serviceName}/documentEnum/getMaxOrderNum`,
    method:'post',
    data
  })
}

export function delContent(data) {
  return request({
    url: `/${serviceName}/documentEnum/delContent`,
    method: 'post',
    data
  })
}

export function saveExcleContent(data) {
  return request({
    url: `/${serviceName}/documentEnum/saveExcleContent`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ppApi.js